import appsFlyer from 'react-native-appsflyer';
import Config from 'react-native-config';
import {api} from '../services/api';
import {getPersistentDeviceId} from '../utils/deviceId';

// Integração do MMP (atribuição de anúncios). Chaves no .env (ver .env.example);
// sem AF_DEV_KEY o SDK não inicializa e o app roda normal.

const devKey = Config.AF_DEV_KEY;
const appId = Config.AF_APP_ID;

export const isAppsFlyerEnabled = Boolean(devKey);

// Fire-and-forget: atribuição nunca pode atrasar nem quebrar o boot do app.
async function postAppsFlyerAttribution(data?: Record<string, any>) {
  if (!data) {
    return;
  }

  try {
    const nativeDeviceId = await getPersistentDeviceId();
    api
      .post('/instalacao', {
        nativeDeviceId,
        appsflyer_id: await getAppsFlyerId(),
        af_status: data.af_status, // 'Non-organic' | 'Organic'
        af_media_source: data.media_source ?? null,
        af_campaign: data.campaign ?? null,
        af_adset: data.adset ?? null,
        af_ad: data.af_ad ?? null,
        // String no Android, boolean no iOS — normaliza para o backend não decidir.
        af_is_first_launch: String(data.is_first_launch) === 'true',
      })
      .catch(() => {});
  } catch (error) {
    console.log('📊 AppsFlyer: falha ao enviar atribuição', error);
  }
}

export function setAppsFlyerCustomerUserId(userId: string) {
  if (!isAppsFlyerEnabled) {
    return;
  }
  appsFlyer.setCustomerUserId(userId);
}

export function initAppsFlyer() {
  if (!devKey) {
    console.log('📊 AppsFlyer: AF_DEV_KEY ausente — SDK não inicializado');
    return;
  }

  // Listeners precisam ser registrados ANTES do initSdk, senão o primeiro callback
  // (justamente o do install) se perde.
  appsFlyer.onInstallConversionData(res => {
    console.log('📊 AppsFlyer conversion data:', JSON.stringify(res?.data));
    // Espelha a atribuição no /instalacao para o BI próprio não depender só do painel.
    postAppsFlyerAttribution(res?.data);
  });

  appsFlyer.onDeepLink(res => {
    if (res?.deepLinkStatus !== 'NOT_FOUND') {
      console.log('📊 AppsFlyer deep link:', JSON.stringify(res?.data));
    }
  });

  appsFlyer.initSdk(
    {
      devKey,
      appId: appId ?? '', // iOS only; Android ignora
      isDebug: Config.RN_ENVIRONMENT !== 'production',
      onInstallConversionDataListener: true,
      onDeepLinkListener: true,
      // iOS: espera o ATT resolver antes de enviar o install, senão vai sem IDFA e
      // perde a atribuição determinística. Libera assim que responde, não espera os 60s.
      timeToWaitForATTUserAuthorization: 60,
    },
    result => console.log('📊 AppsFlyer iniciado:', result),
    error => console.error('📊 AppsFlyer falhou ao iniciar:', error),
  );
}

// appsflyer_id: chave obrigatória do S2S (backend liga a compra de Pix ao install).
export function getAppsFlyerId(): Promise<string | null> {
  if (!isAppsFlyerEnabled) {
    return Promise.resolve(null);
  }

  return new Promise(resolve => {
    appsFlyer.getAppsFlyerUID((error, uid) => {
      if (error) {
        console.log('📊 AppsFlyer: falha ao obter UID', error);
        resolve(null);
        return;
      }
      resolve(uid);
    });
  });
}
